class OfflineStorage {
  initialize() {
    console.log('Offline storage initialized');
  }
}

export const offlineStorage = new OfflineStorage();